// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, STREAM, Weaver, WeaverError, WeaverPlugin, getFs, mime, path, ss;

  ss = require('socket.io-stream');

  path = require('path');

  mime = require('mime-types');

  Weaver = require('./Weaver');

  GET = Weaver.GET;

  POST = Weaver.POST;

  STREAM = Weaver.STREAM;

  WeaverError = require('./Error');

  getFs = function() {
    return require('fs');
  };

  WeaverPlugin = class WeaverPlugin {
    constructor(serverObject) {
      this._name = serverObject.name;
      this._version = serverObject.version;
      this._apiVersion = serverObject.apiVersion || this._version;
      this._author = serverObject.author;
      this._description = serverObject.description;
      this._functions = serverObject.functions;
      this._applicationSecret = serverObject.applicationSecret;
      // Parse functions that will be accessible from @
      serverObject.functions.forEach((f) => {
        return this[f.name] = function(argObject = {}, progressCallback, target) {
          var browserFile, file, fileParameterIndex, fileSize, i, index, j, len, len1, payload, r, readStream, ref, ref1, stream, uploadedBytes;
          // Build payload from arguments based on function require
          payload = {};
          ref = f.require;
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            r = ref[index];
            if (r !== 'file') {
              payload[r] = argObject[r];
            }
          }
          ref1 = f.optional;
          for (index = j = 0, len1 = ref1.length; j < len1; index = ++j) {
            r = ref1[index];
            payload[r] = argObject[r];
          }
          fileParameterIndex = f.require.indexOf('file');
          if (fileParameterIndex > -1) {
            file = argObject['file'];
            // File is a special parameter name which causes a socket stream to
            // be created and its always required
            browserFile = (typeof File !== "undefined" && File !== null) && file instanceof File;
            fileSize = void 0;
            if (browserFile || getFs().existsSync(file)) {
              if (browserFile) {
                fileSize = file.size;
              } else {
                fileSize = getFs().statSync(file).size;
              }
              stream = ss.createStream();
              readStream = browserFile ? ss.createBlobReadStream(file) : getFs().createReadStream(file);
              uploadedBytes = 0;
              readStream.on('data', function(chunk) {
                var percentage;
                uploadedBytes += chunk.length;
                percentage = Math.ceil((uploadedBytes / fileSize) * 100);
                if (progressCallback != null) {
                  return progressCallback(percentage);
                }
              });
              readStream.pipe(stream);
              payload['file'] = stream;
              if (browserFile) {
                payload['_filename'] = file.name;
                payload['_mimeType'] = file.type;
              } else {
                payload['_filename'] = path.basename(file);
                payload['_mimeType'] = mime.lookup(path.extname(file));
              }
            } else {
              throw WeaverError(Weaver.Error.FILE_NOT_EXISTS_ERROR, "File does not exist!");
            }
          }
          // Execute by route and payload
          return STREAM(f.route, payload, target);
        };
      });
    }

    // Load given plugin from server
    static async load(name) {
      var plugin;
      plugin = (await POST("plugin.read", {name}));
      return new WeaverPlugin(plugin);
    }

    // Parse plugin functions for easy reading
    printFunctions() {
      var f, i, len, prettyFunction, ref, results;
      // Example: The function add with require x and y becomes add({x: 'value', y: 'value'})
      prettyFunction = function(f) {
        var args, i, j, len, len1, r, ref, ref1;
        args = "";
        ref = f.require;
        for (i = 0, len = ref.length; i < len; i++) {
          r = ref[i];
          args += `${r}: 'value', `;
        }
        ref1 = f.optional;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          r = ref1[j];
          args += `[${r}: 'value'], `;
        }
        args = args.slice(0, -2); // Remove last comma
        if (args === '') {
          return `${f.name}()`;
        } else {
          return `${f.name}({${args}})`;
        }
      };
      ref = this._functions;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        results.push(prettyFunction(f));
      }
      return results;
    }

    getPluginName() {
      return this._name;
    }

    getPluginVersion() {
      return this._version;
    }

    getPluginAuthor() {
      return this._author;
    }

    getPluginApiVersion() {
      return this._apiVersion;
    }

    getPluginDescription() {
      return this._description;
    }

    getFunctionSignature(functionName) {
      var i, len, ref, struct;
      ref = this._functions;
      for (i = 0, len = ref.length; i < len; i++) {
        struct = ref[i];
        if (struct.name === functionName) {
          return struct.signature;
        }
      }
    }

    static async list() {
      var i, len, p, plugins, results;
      plugins = (await GET("plugins"));
      results = [];
      for (i = 0, len = plugins.length; i < len; i++) {
        p = plugins[i];
        results.push(new WeaverPlugin(p));
      }
      return results;
    }

  };

  module.exports = WeaverPlugin;

}).call(this);
